import { User } from '@/models/gen/graphql';

import createUser from '@/pages/Users/api/services/createUser';
import updateUserBulk from '@/pages/Users/api/services/updateUserBulk';

const createOrUpdateUser = async (ids: (string | null | undefined)[], payload: Partial<User>, user?: Partial<User>) => {
  const existingId = ids.at(0);

  if (existingId) return updateUserBulk(ids, payload, user);

  const created = await createUser(payload as Parameters<typeof createUser>[0]);
  const [result] = created?.createUserBulk?.output || [];

  if (!result || result.error) throw new Error(result?.error || 'createUser: failed to create user');

  // createUser only sets the base profile fields - CreateUserInput has no way to attach
  // licenses/airportCodes/groups. Run the new user through updateUserBulk once so it can diff
  // and attach whatever relational data (e.g. a driver's required license) was set on the form.
  return updateUserBulk([result.node.id], payload, user);
};

export default createOrUpdateUser;
